<template>
	<div class="vedio-desc color-text2">
		【影片上傳說明】
		<br>1.請將影片上傳至雲端硬碟，並於此欄位貼上雲端連結（請勿提供 YouTube 或 Canva 連結）。
		<br>※ 請將連結權限設定為「知道連結的人均可以檢視」，並確認檔案開放下載權限，以利後續下載、整理與使用。
		<br>2.請直接以「故事名稱」作為影片檔名。例如：故事名稱為「改變世界我可以」，影片檔名即為「改變世界我可以」。
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.vedio-desc {
	padding-left: 10%;
	font-size: 14px;
}
</style>